/*
 * DataTablePagination Messages
 *
 * This contains all the strings for the DataTablePagination component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Helper text of pages length
  of: '<span>of</span> {pages}',
  // Helper text of page size
  perPage: 'per page',
  // Button's text of the show all data
  showAll: 'show all',
});
